module.exports = __webpack_public_path__ + "44d6ec0220b5bb084ab5799c1b4d0cb4.fbx";